import api from '../../server';
import { decrypt, getCookie } from "../../utils"

export default {
  namespaced: true,
  state: {
    user: getCookie("account") !== undefined && getCookie("account") !== "" ? JSON.parse(decrypt(getCookie("account"))) : {},
    account: [],
    feedback: {},
    wallets: {},
    withdraw: {},
    sms: {},
    islogin: false,
    showlogin: false
  },
  actions: {
    fetchLoginData ({ commit }, { params }) {
      return api.Login(params).then(data => commit('setAccountData', { data }))
    },
    fetchUserData ({ commit }, { params }) {
      return api.LoginUser(params).then(data => commit('setAccountData', { data }))
    },
    fetchUpdateUser ({ commit }, { params }) {
      return api.updateUser(params).then(data => commit('setAccountUpData', { data }))
    },
    fetchSmsData ({ commit }, { params }) {
      return api.sendSms(params).then(data => commit('setSmsData', { data }))
    },
    fetchAccountData ({ commit }, { params }) {
      return api.Accounts(params).then(data => commit('setUserAccount', { data }))
    },
    fetchFeedback ({ commit }, { params }) {
      return api.Feedback(params).then(data => commit('setUserFeedback', { data }))
    },
    fetchWithdraw ({ commit }, { params }) {
      return api.Withdraw(params).then(data => commit('setUserWithdraw', { data }))
    },
    fetchAlipayUser ({ commit }, { params }) {
      return api.MiniProgramUserInfo(params).then(data => commit('setMiniProgramUserInfo', { data }))
    },
  },
  mutations: {
    setAccountData (state, data) {
      state.user = data.data
    },
    setAccountUpData (state, data) {
      state.user = data.data.data
    },
    setUserAccount (state, data) {
      state.account = data.data
    },
    setUserFeedback (state, data) {
      state.feedback = data.data
    },
    setUserWithdraw (state, data) {
      state.withdraw = data.data
    },
    setSmsData (state, data) {
      state.sms = data.data
    },
    setIsLogin (state, data) {
      state.islogin = data
    },
    setShowLogin (state, data) {
      state.showlogin = data
    },
    setMiniProgramUserInfo (state, data) {
      state.user = data.data
    },
    setUserMobile (state, value) {
      state.user.mobile = value
    }
  }
}